/** Source languages offered for auto-translation. */
export interface TranslationLanguage {
  id: string;
  label: string;
}

export const DETECT_LANGUAGE: TranslationLanguage = { id: 'detect', label: 'Detect Language' };

export const TRANSLATION_LANGUAGES: TranslationLanguage[] = [
  { id: 'detect', label: 'Detect Language' },
  { id: 'af', label: 'Afrikaans' },
  { id: 'sq', label: 'Albanian' },
  { id: 'am', label: 'Amharic' },
  { id: 'ar', label: 'Arabic' },
  { id: 'hy', label: 'Armenian' },
  { id: 'az', label: 'Azeerbaijani' },
  { id: 'eu', label: 'Basque' },
  { id: 'be', label: 'Belarusian' },
  { id: 'bn', label: 'Bengali' },
  { id: 'bs', label: 'Bosnian' },
  { id: 'bg', label: 'Bulgarian' },
  { id: 'ca', label: 'Catalan' },
  { id: 'ceb', label: 'Cebuano' },
  { id: 'zh-CN', label: 'Chinese (Simplified)' },
  { id: 'zh-TW', label: 'Chinese (Traditional)' },
  { id: 'co', label: 'Corsican' },
  { id: 'hr', label: 'Croatian' },
  { id: 'cs', label: 'Czech' },
  { id: 'da', label: 'Danish' },
  { id: 'nl', label: 'Dutch' },
  { id: 'eo', label: 'Esperanto' },
  { id: 'et', label: 'Estonian' },
  { id: 'fi', label: 'Finnish' },
  { id: 'fr', label: 'French' },
  { id: 'fy', label: 'Frisian' },
  { id: 'gl', label: 'Galician' },
  { id: 'ka', label: 'Georgian' },
  { id: 'de', label: 'German' },
  { id: 'el', label: 'Greek' },
  { id: 'gu', label: 'Gujarati' },
  { id: 'ht', label: 'Haitian Creole' },
  { id: 'ha', label: 'Hausa' },
  { id: 'haw', label: 'Hawaiian' },
  { id: 'iw', label: 'Hebrew' },
  { id: 'hi', label: 'Hindi' },
  { id: 'hmn', label: 'Hmong' },
  { id: 'hu', label: 'Hungarian' },
  { id: 'is', label: 'Icelandic' },
  { id: 'ig', label: 'Igbo' },
  { id: 'id', label: 'Indonesian' },
  { id: 'ga', label: 'Irish' },
  { id: 'it', label: 'Italian' },
  { id: 'ja', label: 'Japanese' },
  { id: 'jw', label: 'Javanese' },
  { id: 'kn', label: 'Kannada' },
  { id: 'kk', label: 'Kazakh' },
  { id: 'km', label: 'Khmer' },
  { id: 'ko', label: 'Korean' },
  { id: 'ku', label: 'Kurdish' },
  { id: 'ky', label: 'Kyrgyz' },
  { id: 'lo', label: 'Lao' },
  { id: 'la', label: 'Latin' },
  { id: 'lv', label: 'Latvian' },
  { id: 'lt', label: 'Lithuanian' },
  { id: 'lb', label: 'Luxembourgish' },
  { id: 'mk', label: 'Macedonian' },
  { id: 'mg', label: 'Malagasy' },
  { id: 'ms', label: 'Malay' },
  { id: 'ml', label: 'Malayalam' },
  { id: 'mi', label: 'Maori' },
  { id: 'mr', label: 'Marathi' },
  { id: 'mn', label: 'Mongolian' },
  { id: 'my', label: 'Myanmar (Burmese)' },
  { id: 'ne', label: 'Nepali' },
  { id: 'no', label: 'Norwegian' },
  { id: 'ny', label: 'Nyanja (Chichewa)' },
  { id: 'ps', label: 'Pashto' },
  { id: 'fa', label: 'Persian' },
  { id: 'pl', label: 'Polish' },
  { id: 'pt', label: 'Portuguese' },
  { id: 'pa', label: 'Punjabi' },
  { id: 'ro', label: 'Romanian' },
  { id: 'ru', label: 'Russian' },
  { id: 'sm', label: 'Samoan' },
  { id: 'gd', label: 'Scots Gaelic' },
  { id: 'sr', label: 'Serbian' },
  { id: 'st', label: 'Sesotho' },
  { id: 'sn', label: 'Shona' },
  { id: 'sd', label: 'Sindhi' },
  { id: 'si', label: 'Sinhala (Sinhalese)' },
  { id: 'sk', label: 'Slovak' },
  { id: 'sl', label: 'Slovenian' },
  { id: 'so', label: 'Somali' },
  { id: 'es', label: 'Spanish' },
  { id: 'su', label: 'Sundanese' },
  { id: 'sw', label: 'Swahili' },
  { id: 'sv', label: 'Swedish' },
  { id: 'tl', label: 'Tagalog (Filipino)' },
  { id: 'tg', label: 'Tajik' },
  { id: 'ta', label: 'Tamil' },
  { id: 'te', label: 'Telugu' },
  { id: 'th', label: 'Thai' },
  { id: 'tr', label: 'Turkish' },
  { id: 'uk', label: 'Ukrainian' },
  { id: 'ur', label: 'Urdu' },
  { id: 'uz', label: 'Uzbek' },
  { id: 'vi', label: 'Vietnamese' },
  { id: 'cy', label: 'Welsh' },
  { id: 'xh', label: 'Xhosa' },
  { id: 'yi', label: 'Yiddish' },
  { id: 'yo', label: 'Yoruba' },
  { id: 'zu', label: 'Zulu' }
];
